import { render, staticRenderFns } from "./ChartTemplate.vue?vue&type=template&id=c2496b0c&"
import script from "./ChartTemplate.vue?vue&type=script&lang=js&"
export * from "./ChartTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports